import { GetServerSidePropsContext } from "next";

import { ENV, DOMAIN_WHEN_LOCALHOST, ENABLE_TOOLKIT } from "@/src/const";
import { StringHelper } from "@/src/util";

function isToolkitEnabled(hostname: string) {
  return (
    ENABLE_TOOLKIT || hostname === "dev-toolkit.notflow.life" || hostname === "toolkit.notflow.life" || hostname === "stage-toolkit.notflow.life"
  );
}

function getPathRootPrefix(hostname: string) {
  if (!hostname) {
    return "c";
  }

  const flowSites = ["flow.life", "notflow.life", "www.flow.life", "notflow.life", "www.tracemidtown.com", "tracemidtown.com"];
  if (flowSites.includes(hostname)) {
    return undefined;
  }
  return "c";
}

function getDomainWhenLocalhost(): string {
  const domain = (DOMAIN_WHEN_LOCALHOST ?? "").length > 1 ? DOMAIN_WHEN_LOCALHOST : undefined;
  switch (ENV) {
    case "dev":
    case "local":
      return domain ?? "dev.notflow.life";
    case "prod":
      return domain ?? "flow.life";
    default:
      return "localhost";
  }
}

function getAllParams(context: GetServerSidePropsContext) {
  const domain = StringHelper.checkIsStringOrIsNull(context.req.headers?.["x-forwarded-host"] ?? context.req.headers?.host, "flow.life");
  const hostname = domain.includes("localhost") ? getDomainWhenLocalhost() : domain.split(":")[0];
  const isToolkit = isToolkitEnabled(hostname);
  const toolkitDomain = StringHelper.checkIsStringOrIsNull(context?.query?.toolkitDomain, "").toLowerCase();
  const toolkitHostname = isToolkit ? (toolkitDomain ?? getDomainWhenLocalhost()) : hostname;
  const byPassCache: boolean = StringHelper.checkIsStringOrIsNull(context?.query?.cache, "false").toLowerCase() === "bypass";
  const isPreview: boolean = StringHelper.checkIsStringOrIsNull(context?.query?.preview, "false").toLowerCase() === "true";
  const returnHeaders: boolean = StringHelper.checkIsStringOrIsNull(context?.query?.headers, "false").toLowerCase() === "true";
  const trackingOff: boolean = StringHelper.checkIsStringOrIsNull(context?.query?.tracking, "false").toLowerCase() === "disable";
  const locale: string = isPreview ? "en-PW" : StringHelper.checkIsStringOrIsNull(context?.params?.locale, "en").toLowerCase();

  return {
    domain,
    hostname: isToolkit ? toolkitHostname : hostname,
    byPassCache,
    isPreview,
    returnHeaders,
    trackingOff,
    locale,
    isToolkit,
  };
}

export default {
  getAllParams,
  getDomainWhenLocalhost,
  isToolkitEnabled,
  getPathRootPrefix,
};
